import { ASSESSMENT_BASE_URL } from 'config/app.config';
import { track } from './analytics';

/**
 * Quiz events (Sol mixpanel-coverage D1 A). The lesson quiz runs in the quiz app inside the world's board; it already
 * tells the player about each submitted answer (assessmentQuestionSubmitted) and the finished session
 * (assessmentSessionSummary). Only messages from the quiz app's own address count, and only correctness and ids are
 * kept - never the answer.
 */
const quizOrigin = () => {
  try {
    return new URL(ASSESSMENT_BASE_URL).origin;
  } catch (_) {
    return null;
  }
};

const idOf = value => (value == null || value === '' ? null : String(value));
const numberOf = value => (Number.isFinite(Number(value)) ? Number(value) : null);

export function trackQuizStarted({ lessonId, unitId, courseId }, send = track) {
  return send('quiz_started', { quiz_id: idOf(lessonId), lesson_id: idOf(lessonId), unit_id: idOf(unitId), course_id: idOf(courseId) });
}

export function trackQuizMessage(origin, data, send = track, expectedOrigin = quizOrigin()) {
  if (!data || typeof data !== 'object' || !expectedOrigin || origin !== expectedOrigin) return null;
  const lessonId = idOf(data.lessonId || data.lesson_id);
  const unitId = idOf(data.unitId || data.unit_id);
  if (data.type === 'assessmentQuestionSubmitted') {
    const attempt = numberOf(data.attemptIndex);
    return send('quiz_answer_submitted', {
      quiz_id: lessonId,
      lesson_id: lessonId,
      unit_id: unitId,
      question_id: idOf(data.questionId),
      attempt_number: attempt == null ? null : attempt + 1,
      is_correct: data.isCorrect === true,
    });
  }
  if (data.type === 'assessmentSessionSummary') {
    const score = numberOf(data.finalScorePct);
    return send('quiz_completed', {
      quiz_id: lessonId,
      lesson_id: lessonId,
      unit_id: unitId,
      score_percent: score == null ? null : Math.round(score),
      question_count: numberOf(data.totalQuestions),
      correct_count: numberOf(data.correctCount),
    });
  }
  return null;
}
